import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { get, map } from "lodash";

import { fetchGet, fetchPost } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import Checkbox from "@material-ui/core/Checkbox";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";
import FormSection from "../../Common/FormSection";
import ProfileSearchInput from "../../Common/ProfileSearchInput";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";
import { isAllowed } from "../../../utils/users";

const styles = {
  dialog: {
    minWidth: "370px",
  },
  title: {
    textTransform: "uppercase",
    color: colors.black87,
    fontWeight: 500,
  },
  radioGroup: {
    flexDirection: "row",
  },
  formControlRoot: {
    marginRight: "24px",
  },
  plusIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
};

const AddAssociations = (props) => {
  const { classes, language, profile, refresh, permissions } = props;

  const [open, setOpen] = React.useState(false);
  const [formValues, setFormValues] = React.useState({});
  const [addAnother, setAddAnother] = React.useState(false);
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    if (open && !lov) {
      fetchLov();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const fetchLov = async () => {
    try {
      setLov({
        association_types: await fetchGet("association_types?active=true"),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const reset = () => {
    setFormValues({});
  };

  const onClose = () => {
    reset();
    setOpen(false);
  };

  const handleChange = (id, index, value) => {
    setFormValues(
      update(formValues, {
        [id]: { $set: value },
      })
    );
  };

  const submit = async () => {
    try {
      await fetchPost("profile_associations", {
        p1_profile_id: get(formValues, ["profile", "id"]),
        p2_profile_id: get(profile, ["id"]),
        p1_association_type_id: get(formValues, ["p1_association_type_id"]),
        description: "",
        active: true,
      });
      reset();
      if (!addAnother) setOpen(false);
      refresh();
    } catch (e) {
      console.log(e);
    }
  };

  const isValidForm = () => {
    let isValid = true;
    if (!get(formValues, ["profile"])) isValid = false;
    if (!get(formValues, ["p1_association_type_id"])) isValid = false;
    return isValid;
  };

  return (
    <>
      <Box
        className={classes.plusIcon}
        onClick={() =>
          isAllowed(permissions, "profile_associations.create")
            ? setOpen(true)
            : ""
        }
      >
        <img
          src={
            isAllowed(permissions, "profile_associations.create")
              ? images.plusIconColored
              : images.plusIconDarkGrey
          }
          alt="plus"
        />
      </Box>
      <Dialog
        open={open}
        classes={{
          paperScrollPaper: classes.dialog,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ paddingTop: "24px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs container direction="column" alignItems="center">
                <Grid item className="dialogTitle">
                  {I18n.get("profiles_addAssociationTo")}
                </Grid>
                <Grid item className="text-54">
                  {get(profile, ["name"])}
                </Grid>
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={onClose} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ padding: "24px" }}>
            <Grid container direction="column">
              <ProfileSearchInput
                profileType={1}
                allTypes
                title={"humanProfile"}
                selectProfile={(profile) =>
                  handleChange("profile", null, profile)
                }
                selectedProfile={get(formValues, ["profile"])}
                excludeProfileIds={[get(profile, ["id"])]}
                sizes={{
                  input: 320,
                  inputDropdown: 350,
                  profile: 420,
                }}
                required
                express
                minHeight={get(formValues, ["profile"]) ? null : 225}
                noMinHeight={get(formValues, ["profile"]) ? true : false}
                noLabel
                style={{ paddingTop: "22px", marginTop: "-6px" }}
                newProfilePhotos={get(formValues, ["photos"])}
                placeholder={I18n.get("profiles_searchProfile")}
              />
              {get(formValues, ["profile"]) && (
                <Grid
                  item
                  style={{
                    padding: "20px 8px 0px 8px",
                    backgroundColor: colors.lightGrey,
                  }}
                >
                  <Grid container alignItems="center">
                    <Grid
                      item
                      className="bold-500"
                      style={{ marginRight: "6px", marginBottom: "12px" }}
                    >
                      {I18n.get("profiles_is")}
                    </Grid>
                    <Grid item xs>
                      <FormSection
                        formValue={[
                          get(formValues, ["p1_association_type_id"]) || "",
                        ]}
                        setFormValue={handleChange}
                        id="p1_association_type_id"
                        type="select"
                        noLabel
                        options={{
                          comboBox: true,
                          options: map(
                            get(lov, ["association_types"]),
                            (item) => ({
                              id: item.id,
                              name: get(item, [`name_${language}`]),
                            })
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid
                item
                container
                alignItems="center"
                justify="center"
                style={{ margin: "40px 0px 24px" }}
              >
                <Checkbox
                  color="primary"
                  checked={addAnother}
                  onChange={(e) => setAddAnother(e.target.checked)}
                />
                <span className="text-54">
                  {I18n.get("profiles_addAnother")}
                </span>
              </Grid>
              <Grid item>
                <Grid container justify="center">
                  <Grid item>
                    <CustomButton color="primary" onClick={onClose}>
                      {I18n.get("site_cancel")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ marginLeft: "10px" }}>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      disabled={!isValidForm()}
                      onClick={submit}
                    >
                      {I18n.get("site_confirm")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(AddAssociations));
